module.exports = __webpack_public_path__ + "assets/img/bingoLogo.fad9a89a.svg";